module.exports = __webpack_public_path__ + "images/emoji/anger.70dadb96de69ea7a720b.png";